import { DateTime } from 'luxon'
import { ILenConfigState } from '../../../store/types'

export interface IManualVerificationPageProps {
   isManualVerificationFailPage: boolean;
}

export interface ManualVerificationPageProps {
   lenConfigState: ILenConfigState;
   closeConnection: () => void;
}
export interface ManualVerificationPageContentProps {
   textContent: (key: string) => string;
   confirmManualVerificationDefaultMethod: () => Promise<void>;
   htmlContentBasedOnDate: string;
   isConfirmationButtonLoading: boolean;
   clientConsentManualVerificationHasError: boolean;
   showManualVerificationClosePage: boolean;
}

export  interface IManualVerificationPageHubRedirectionContentProps {
   textContent: (key: string) => string;
   htmlContentBasedOnDate: string;
}

export interface GetManualVerificationContentProps {
   textContent: (key: string, vars?: Record<string, string>) => string;
   manualVerificationPageHubVerificationState: MANUAL_VERIFICATION_PAGE_VERIFICATION_STATES;
   manualVerificationPhoneNumber: string;
   workFrom: string;
}

export interface IManualVerificationReturnModel {
   confirmManualVerificationDefaultMethod: () => Promise<void>;
   htmlContentBasedOnDate: string;
   htmlContentDetailsBasedOnDate: string;
   hasClientConsentManualVerification: boolean;
   clientConsentManualVerificationHasError: boolean;
   isConfirmationButtonLoading: boolean;
}

export enum MANUAL_VERIFICATION_PAGE_VERIFICATION_STATES {
   TODAY = "TODAY",
   TODAY_AFTER_MIDNIGHT = "TODAY_AFTER_MIDNIGHT",
   TOMORROW = "TOMORROW",
   NEXT_WORKDAY = "NEXT_WORKDAY",
}